import { Link } from "react-router-dom";
import { Play, Camera, ArrowRight } from "lucide-react";
import ScrollReveal from "./ScrollReveal";
import { useLanguage } from "@/i18n/LanguageContext";
import fotoCover from "@/assets/DSC04156.jpg";

const PortfolioSplitSection = () => {
  const { t } = useLanguage();
  const isEn = t.contact.footer === "better pictures";

  return (
    <section id="portfolio" className="py-6 md:py-10 px-6">
      <div className="max-w-6xl mx-auto">
        <ScrollReveal>
          <span className="block text-center text-accent text-xs font-mono tracking-widest uppercase">
            [ PORTFOLIO // 01 ]
          </span>
        </ScrollReveal>

        <ScrollReveal delay={100}>
          <h2 className="mt-4 text-center text-3xl md:text-4xl lg:text-5xl font-bold text-foreground glitch cursor-default uppercase">
            {isEn ? "Portfolio" : "Portfolio"}
          </h2>
        </ScrollReveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* FOTO — left */}
          <ScrollReveal delay={200}>
            <Link
              to="/foto"
              className="group relative aspect-video md:aspect-[4/3] overflow-hidden block border border-foreground/15 hover:border-accent/60 transition-all duration-300"
            >
              <img
                src={fotoCover}
                alt="Portfolio fotograficzne — Michał Wencek, fotograf reklamowy"
                loading="lazy"
                decoding="async"
                style={{ objectPosition: "center 35%" }}
                className="w-full h-full object-cover opacity-70 brightness-90 saturate-95 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100 group-hover:brightness-105 group-hover:saturate-100"
              />
              <div className="absolute inset-0 bg-background/30 group-hover:bg-background/0 transition-colors duration-500" />
              <div className="absolute top-3 left-3 font-mono text-[10px] text-accent tracking-widest z-10">[01_FOTO.JPG]</div>
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
                <Camera
                  strokeWidth={1.25}
                  className="w-12 h-12 text-foreground/80 transition-all duration-300 group-hover:text-accent group-hover:scale-110"
                />
                <h3 className="text-foreground text-2xl md:text-4xl font-bold tracking-tight">
                  FOTO
                </h3>
                <span className="inline-flex items-center gap-2 text-accent text-xs font-mono uppercase tracking-widest transition-colors">
                  {'>>'} {isEn ? "View frames" : "Zobacz kadry"}
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          </ScrollReveal>

          {/* WIDEO — right */}
          <ScrollReveal delay={300}>
            <Link
              to="/wideo"
              className="group relative aspect-video md:aspect-[4/3] overflow-hidden block border border-foreground/15 hover:border-accent/60 transition-all duration-300"
            >
              <img
                src="https://i.vimeocdn.com/video/1534080621-d04faf331f9e046654086cfdf7f7aa9e6cb5cde7a7b0d218a7cf6c3a871ac14a-d_960x540"
                alt="Portfolio wideo — produkcje filmowe Michała Wencka (Pezet — Ukryty W Mieście Krzyk)"
                loading="lazy"
                style={{ objectPosition: "center 30%" }}
                className="w-full h-full object-cover opacity-70 brightness-90 saturate-95 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100 group-hover:brightness-105 group-hover:saturate-100"
              />
              <div className="absolute inset-0 bg-background/30 group-hover:bg-background/0 transition-colors duration-500" />
              <div className="absolute top-3 left-3 font-mono text-[10px] text-accent tracking-widest z-10">[02_WIDEO.MP4]</div>
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
                <Play
                  strokeWidth={1.25}
                  className="w-12 h-12 text-foreground/80 transition-all duration-300 group-hover:text-accent group-hover:scale-110 ml-1"
                />
                <h3 className="text-foreground text-2xl md:text-4xl font-bold tracking-tight">
                  WIDEO
                </h3>
                <span className="inline-flex items-center gap-2 text-accent text-xs font-mono uppercase tracking-widest transition-colors">
                  {'>>'} {isEn ? "View productions" : "Zobacz realizacje"}
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSplitSection;
